<template>
  <Loading v-if="componentLoading" />
  <Chart v-else :option="chartOption" style="height: 100%" />
</template>
<script setup lang="ts">
import { ref } from "vue"
import { cloneDeep, defaultsDeep } from "lodash-es"
import defaultConfig, { barConfig as barConfigTpl } from "./config"
import Chart from "@p-v/packages/Charts/BaseChart/index.vue"
import Loading from "@p-v/packages/Loading.vue"
import { EChartsOption } from "echarts"

const componentLoading = ref<boolean>(true)

export interface StackBarChartData {
  dimensions: string[] // 第一个元素为x轴，后续为y轴
  names?: string[] // 名称
  source: { [key: string]: number }[] // 数据
  barConfig?: { [key: string]: string }
}

interface StackBarChartOption {
  data: StackBarChartData
  config?: { [key: string]: string }
}

// 引入模板配置
const chartOption = ref(cloneDeep(defaultConfig))

// 定义组件Props
withDefaults(defineProps<StackBarChartOption>(), {
  data: () => ({ dimensions: [], source: [], names: [], barConfig: {} }),
  config: () => ({}),
})

function componentPropEngine(propsData: StackBarChartOption): EChartsOption {
  const { data, config: _config } = propsData
  const newConfig = cloneDeep(defaultConfig)
  const configFromProp = cloneDeep(_config)
  const configResult = defaultsDeep(configFromProp, newConfig)
  const { dimensions, source, names, barConfig: newBarConfig } = data

  const barConfig = defaultsDeep(newBarConfig, barConfigTpl)

  let hasData = false

  configResult.series = Array.from({ length: dimensions.length - 1 }, (_, index) => {
    const fillData = source.map(item => item[dimensions[index + 1]])
    if (!hasData && fillData.length > 0) {
      hasData = true
    }
    return defaultsDeep(
      {
        name: (names && names[index]) || "",
        type: "bar",
        // stack: "总量",
        data: fillData,
      },
      barConfig,
    )
  })

  configResult.xAxis.data = source.map(item => item[dimensions[0]])

  // configResult.series[0].data = data;
  // 移除暂无数据的文本
  if (hasData) {
    // delete configResult.graphic;
    configResult.graphic[0].invisible = true
  } else {
    configResult.xAxis = {
      show: false,
    }
    configResult.yAxis = {
      show: false,
    }
    configResult.series = []
  }

  return configResult
}

const loading = () => {
  componentLoading.value = true
}
const setData = (data: StackBarChartData | { data: StackBarChartData; config: { [key: string]: string } }, option?: { [key: string]: string }) => {
  if (!data) return
  if ((data as StackBarChartOption).data) {
    const result = componentPropEngine(data as StackBarChartOption)
    componentLoading.value = false
    chartOption.value = result as any
  } else {
    const result = componentPropEngine({ data: data as StackBarChartData, config: option })
    componentLoading.value = false
    chartOption.value = result as any
  }
}
defineExpose({ setData, loading })
</script>
